/* Coordinates the existing PDP purchase bar with the visual viewport and overlays.
   Cart submission remains owned by wvo-product-page; this file never submits a cart. */
(function () {
  'use strict';
  var bar = document.querySelector('[data-sticky-bar]');
  var trigger = document.querySelector('[data-add-to-cart]');
  if (!bar || !trigger || bar.dataset.viewportReady) return;
  bar.dataset.viewportReady = 'true';

  var frame = 0;
  var chatRoot;
  var bodyPadding = document.body.style.paddingBottom;
  var initialPadding = parseFloat(getComputedStyle(document.body).paddingBottom) || 0;
  var watched = new WeakSet();
  var chatObserver = new MutationObserver(schedule);
  var resizeObserver = window.ResizeObserver ? new ResizeObserver(schedule) : null;

  function setStyle(el, name, value) {
    if (el && el.style.getPropertyValue(name) !== value) el.style.setProperty(name, value);
  }
  function setAttribute(el, name, value) {
    if (el && el.getAttribute(name) !== value) el.setAttribute(name, value);
  }
  function visible(el) {
    if (!el || el.hidden || el.getAttribute('aria-hidden') === 'true') return false;
    var style = getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && el.getClientRects().length > 0;
  }
  function watchSize(el) {
    if (resizeObserver && el && !watched.has(el)) {
      watched.add(el);
      resizeObserver.observe(el);
    }
  }
  function schedule() {
    if (!frame) frame = requestAnimationFrame(function () { frame = 0; check(); });
  }
  function covered(r) {
    // Ignore only controls this coordinator moves. Otherwise its own bar could
    // keep itself visible forever. Test edges as well as the button centre.
    var middleX = (r.left + r.right) / 2;
    var middleY = (r.top + r.bottom) / 2;
    var style = getComputedStyle(trigger);
    function cornerInset(radius) {
      return Math.min(r.width / 2, r.height / 2, (parseFloat(radius) || 0) + 2);
    }
    var tl = cornerInset(style.borderTopLeftRadius);
    var tr = cornerInset(style.borderTopRightRadius);
    var bl = cornerInset(style.borderBottomLeftRadius);
    var br = cornerInset(style.borderBottomRightRadius);
    var points = [[middleX, middleY], [middleX, r.top + 2], [middleX, r.bottom - 2],
      [r.left + 2, middleY], [r.right - 2, middleY], [r.left + tl, r.top + tl],
      [r.right - tr, r.top + tr], [r.left + bl, r.bottom - bl], [r.right - br, r.bottom - br]];
    return points.some(function (point) {
        var x = point[0], y = point[1];
        var elements = document.elementsFromPoint(x, y);
        var top = elements.find(function (el) {
          return !bar.contains(el) && !el.closest('shopify-chat, #wvoNlFloat, #wvoBtt');
        });
        return !top || (top !== trigger && !trigger.contains(top));
    });
  }
  function check() {
    if (!document.body || !bar.isConnected || !trigger.isConnected) return;
    var vv = window.visualViewport;
    var top = vv ? vv.offsetTop : 0;
    var left = vv ? vv.offsetLeft : 0;
    var bottom = top + (vv ? vv.height : window.innerHeight);
    var right = left + (vv ? vv.width : window.innerWidth);
    var cookie = document.getElementById('wvoCk');
    var cookieOpen = cookie && cookie.getAttribute('aria-hidden') === 'false';
    var prefs = cookie && cookie.querySelector('[data-ck-prefs]');
    var prefsOpen = cookieOpen && prefs && prefs.getAttribute('aria-hidden') === 'false';
    watchSize(cookie);
    var usableBottom = bottom;
    if (cookieOpen) {
      // Reserve the final banner height even during its slide-in transition.
      usableBottom = Math.min(bottom, window.innerHeight - cookie.offsetHeight) - 8;
    }

    var chat = document.querySelector('shopify-chat');
    if (chat && chat.shadowRoot && chatRoot !== chat.shadowRoot) {
      chatObserver.disconnect();
      chatRoot = chat.shadowRoot;
      chatObserver.observe(chatRoot, {subtree: true, childList: true, attributes: true, attributeFilter: ['open', 'aria-expanded', 'view']});
    }
    var chatOpen = !!(chatRoot && chatRoot.querySelector('shopify-agent-runtime[open], [part~="activator"][aria-expanded="true"]'));
    var modal = Array.prototype.some.call(document.querySelectorAll(
      '[role="dialog"][aria-hidden="false"], dialog[open], .wvo-product__lightbox[aria-hidden="false"], .menu-mobile.show, .menu-mobile.is-open, .menu-mobile.active'
    ), function (el) { return el !== cookie && visible(el); });
    modal = modal || document.body.classList.contains('wvo-cart-open') || !!document.querySelector('.js-menu-mobile[aria-expanded="true"]');

    var r = trigger.getBoundingClientRect();
    var usable = visible(trigger) && r.width > 0 && r.height > 0 &&
      r.top >= top && r.bottom <= usableBottom && r.left >= left && r.right <= right && !covered(r);
    var barHeight = bar.offsetHeight;
    var noSpace = usableBottom - top < barHeight + 44;
    var show = !usable && !modal && !chatOpen && !prefsOpen && !noSpace;
    var offset = Math.max(0, window.innerHeight - usableBottom);
    setStyle(bar, '--wvo-sticky-bottom', offset + 'px');
    if (bar.classList.contains('is-visible') !== show) bar.classList.toggle('is-visible', show);
    setAttribute(bar, 'aria-hidden', show ? 'false' : 'true');
    if (bar.inert === show) bar.inert = !show;
    setAttribute(bar, 'data-main-usable', usable ? 'true' : 'false');
    setAttribute(bar, 'data-suppressed', modal || chatOpen || prefsOpen || noSpace ? 'true' : 'false');
    var reserve = show ? barHeight + offset : 0;
    var padding = reserve ? (initialPadding + reserve) + 'px' : bodyPadding;
    if (document.body.style.paddingBottom !== padding) document.body.style.paddingBottom = padding;

    // Inbox exposes this CSS variable publicly: no shadow-DOM style injection.
    // Hide the closed launcher during consent/modal decisions. An open chat
    // remains usable, while the purchase bar yields to it.
    if (chat) {
      setAttribute(chat, 'data-wvo-obscured', cookieOpen || modal ? 'true' : 'false');
      var chatOffset = Math.max(20, window.innerHeight - bottom + 20);
      if (show) chatOffset = Math.max(chatOffset, offset + barHeight + 12);
      if (usable && r.bottom > top && r.top < bottom) chatOffset = Math.max(chatOffset, window.innerHeight - r.top + 12);
      setStyle(chat, '--shopify-chat-activator-offset', chatOffset + 'px');
    }
    var newsletter = document.getElementById('wvoNlFloat');
    setAttribute(newsletter, 'data-wvo-obscured', cookieOpen || modal || chatOpen || show ? 'true' : 'false');
    var backToTop = document.getElementById('wvoBtt');
    setAttribute(backToTop, 'data-wvo-obscured', cookieOpen || modal || chatOpen ? 'true' : 'false');
    setStyle(backToTop, 'bottom', show ? (reserve + 16) + 'px' : '');
  }

  watchSize(bar);
  watchSize(trigger);
  // Attribute filtering avoids loops caused by our own positioning styles.
  var overlaySelector = '[role="dialog"], dialog, .menu-mobile, .js-menu-mobile, #wvoCk, #wvoCart, shopify-chat, .wvo-product__lightbox';
  function relevantMutation(records) {
    return records.some(function(record) {
      var el = record.target;
      if (el === bar || bar.contains(el)) return false;
      if (record.type === 'attributes') {
        if (el === document.body || el.matches(overlaySelector) || el.contains(trigger) || el === trigger || el.closest('[role="dialog"], dialog')) return true;
        return !el.closest('.wvo-reviews, .wvo-bestsellers, .wvo-product__thumbs, .wvo-gallery__dots, .wvo-announce__slider');
      }
      // Any new/removed element may occlude the main button, including app UI
      // without dialog semantics. Preserve that check instead of an allowlist.
      return record.addedNodes.length > 0 || record.removedNodes.length > 0;
    });
  }
  var observer = new MutationObserver(function(records) { if (relevantMutation(records)) schedule(); });
  observer.observe(document.body, {subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden', 'aria-expanded', 'open', 'class']});
  window.addEventListener('scroll', schedule, {passive: true});
  window.addEventListener('resize', schedule, {passive: true});
  window.addEventListener('pageshow', schedule);
  window.addEventListener('wvoConsentUpdated', schedule);
  document.addEventListener('transitionend', function(event) {
    if (event.target.matches(overlaySelector) || event.target.contains(trigger)) schedule();
  });
  document.addEventListener('load', function(event) { if (event.target.tagName === 'IMG') schedule(); }, true);
  watchSize(document.querySelector('.wvo-product__container'));
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', schedule, {passive: true});
    window.visualViewport.addEventListener('scroll', schedule, {passive: true});
  }
  check();
})();
